module.exports = __webpack_public_path__ + "static/media/phone-8.c6f58491.svg";